/**
 * Beta Gate Wrapper Component
 * Wraps the entire app with waitlist modal and provides gating context
 */

import React, { createContext, useContext } from 'react';
import useBetaGate from '../hooks/useBetaGate';
import WaitlistModal from './WaitlistModal';

// Create context for beta gating
const BetaGateContext = createContext();

export const useBetaGateContext = () => {
  const context = useContext(BetaGateContext);
  if (!context) {
    throw new Error('useBetaGateContext must be used within BetaGateWrapper');
  }
  return context;
};

const BetaGateWrapper = ({ children }) => {
  const betaGateHook = useBetaGate();

  return (
    <BetaGateContext.Provider value={betaGateHook}>
      {children}
      
      {/* Global Waitlist Modal */}
      <WaitlistModal 
        isOpen={betaGateHook.modalOpen}
        onClose={betaGateHook.closeModal}
        triggerAction={betaGateHook.triggerAction}
      />
    </BetaGateContext.Provider>
  );
};

export default BetaGateWrapper;